import { NULL_CONTIGENT_ID } from '../../../models/contingent';
import Contingent from '../contingent';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@weezevent/nacre';

export default class StepOne extends React.Component {
    unset() {
        this.props.unassignContingent();
    }

    renderUnassignContingent() {
        if (!this.props.canUnassignContingent) {
            return null;
        }

        return (
            <Button primary inverted fluid onClick={() => this.unset()}>
                <Trans i18nKey="seats_selection_unset_contingent_action">Unavailable</Trans>
            </Button>
        );
    }

    render() {
        let { seats } = this.props;

        let contingentsData = {};

        seats.forEach(seat => {
            let key = seat.contingent || NULL_CONTIGENT_ID;
            contingentsData[key] = contingentsData[key] || [];
            contingentsData[key].push(seat);
        });

        let contingents = Object.keys(contingentsData)
            .map(contingentId => this.props.contingents.find(({ uuid }) => uuid === contingentId) || null)
            .filter(contingent => contingent)
            .sort((one, another) => (one.name < another.name ? -1 : 1));

        return (
            <>
                <ul className="contingents">
                    {contingents.map(contingent => (
                        <Contingent key={contingent.uuid} contingent={contingent} inList seats={contingentsData[contingent.uuid]} />
                    ))}
                </ul>
                {this.renderUnassignContingent()}
            </>
        );
    }
}

StepOne.propTypes = {
    canUnassignContingent: PropTypes.bool.isRequired,
    contingents: PropTypes.array.isRequired,
    seats: PropTypes.array.isRequired,
    unassignContingent: PropTypes.func.isRequired
};
